import type { AboutPageLocations } from '@/types/ga4/tracking-locations'

export const ABOUT_HERO_LOCATION = 'about_hero'
export const ABOUT_TESTIMONIALS_LOCATION = 'about_testimonials'
export const ABOUT_FAQ_LOCATION = 'about_faq'
export const ABOUT_BLOG_CAROUSEL_LOCATION = 'about_blog_carousel'
export const ABOUT_CTA_BANNER_LOCATION = 'about_cta_banner'

export const ABOUT_PAGE_LOCATIONS = {
	hero: ABOUT_HERO_LOCATION,
	testimonials: ABOUT_TESTIMONIALS_LOCATION,
	faq: ABOUT_FAQ_LOCATION,
	blogCarousel: ABOUT_BLOG_CAROUSEL_LOCATION,
	ctaBanner: ABOUT_CTA_BANNER_LOCATION
} as const satisfies AboutPageLocations
